import { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import './App.css';
import Logopikku from "./Pro2.jpg";
import Pro from "./Pro2.jpg";
import Volume from "./volume2";
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import Simulator from "./haastattelusimu";


function AuthenticationForm2({ onAddLogin, onAddHaastattelu }) {
    const [isLoginForm, setIsLoginForm] = useState(false);
    const [email, setEmail] = useState(""); //Käyttäjän syöttämä ID
    const [name, setName] = useState(""); //Mikä yritys, prosource
    const [pageNumber, setpageNumber] = useState(1);
    const [kysymykset, setKysymykset] = useState([]); //Back palauttaa kyssärit tähän.
    const [haastattelu, setHaastettelu] = useState(false);
    const [position, setPosition] = useState(""); //Back palauttaa kyssärit tähän.
    const [owner, setOwner] = useState(""); //konsultti
    const [mandaatti, setMandaatti] = useState(""); //konsultti
    const [kieli, setKieli] = useState(""); //konsultti
    const [ehdot, setEhdot] = useState(""); //konsultti
    const [isAccepted, setIsAccepted] = useState(false);
    const [time, setTime] = useState(0);

    //napit

    const [oikealle, setOikealle] = useState(""); 
    const [vasemmalle, setVasemmalle] = useState(""); 
    const [valmisNappi, setValmisNappi] = useState(""); 
    
    const oikealleFin = "Seuraava";
    const vasemmalleFin = "Edellinen";
    const valmisNappiFin = "Aloita haastattelu!";

   
    

    const oikealleEng = "Next";
    const vasemmalleEng = "Previous";
    const valmisNappiEng = "Start the interview!";

    const oikealleSwe = "Nästa";
    const vasemmalleSwe = "Föregående";
    const valmisNappiSwe = "Börja intervjun!";



    const {
      transcript,
      resetTranscript,
      browserSupportsSpeechRecognition
    } = useSpeechRecognition();

    const [ohjeet, setOhjeet] =useState ([
     
    ]);

    const ohjeetFin =[
      "<h2>Tervetuloa</h2><p>Hei, hienoa, kun tulit tänne!<br/><br/>Tämä haastattelu on tehty niin helpoksi kuin mahdollista. Sinun tarvitsee vain vastata kysymyksiin ääneen, alusta hoitaa kaiken muun automaattisesti.<br/><br/>Vastauksesi lähetetään suoraan rekrytointivastuulliselle, joka käy ne läpi. Vastausten lopullinen arviointi tapahtuu aina ihmisen toimesta.<br/><br/>Käydään seuraavaksi lyhyesti ohjeet läpi. Tämä vie maksimissaan muutaman minuutin.</p>",
      `<h2>Näin haastattelu etenee</h2><p>Alusta ohjaa sinut automaattisesti eteenpäin – sinun tarvitsee vain vastata kysymyksiin puhumalla.<br/><br/>Jokaisen kysymyksen kohdalla:<br/>- Saat 20 sekuntia lukea kysymyksen rauhassa<br/>- Sen jälkeen sinulla on ${time} sekuntia vastata ääneen<br/><br/>Kun aika täyttyy, alusta siirtyy automaattisesti seuraavaan kysymykseen.<br/><br/>Jos olet vastannut ennen ajan loppumista, voit siirtyä seuraavaan kysymykseen itse painamalla "Seuraava kysymys" -nappia.<br/><br/>Haastattelu etenee kerralla alusta loppuun – sitä ei voi keskeyttää ja jatkaa myöhemmin. Tämä varmistaa, että kaikki haastateltavat ovat samalla viivalla toistensa kanssa.</p>`,
      "<h2>Mikrofonin tarkistus</h2><p>Tarkistetaan ensin, että mikrofoni toimii.<br/><br/>Alusta pyytää lupaa käyttää mikrofoniasi. Hyväksy pyyntö, kun selain kysyy.<br/><br/>Tarkista mikrofonin toiminta alla olevasta äänenvoimakkuuspalkista – kun puhut, palkin pitäisi liikkua. Jos se ei reagoi, tarkista laitteesi mikrofoniasetukset ennen kuin jatkat.</p>",
      `<h2>Kysymyksiä on ${kysymykset.length}</h2><p>Olet kohta valmis aloittamaan!<br/><br/>Kun olet vastannut viimeiseen kysymykseen, alusta vahvistaa, että haastattelu on päättynyt ja vastauksesi on lähetetty eteenpäin.<br/><br/>Huom: Vahvistus saattaa joskus kestää hetken. Älä siis huolestu, vaikka sivu näyttäisi latautuvan. Vastauksesi tallentuvat ja lähtevät kuitenkin eteenpäin automaattisesti. Voit sulkea sivun turvallisesti myös ennen vahvistusviestiä.</p>`,
      "<h2>Yksityisyydensuoja</h2><p>Lue yksityisyydensuojaa koskevat tiedot alla olevasta linkistä ennen haastattelun aloittamista.<br/> <br/><a href='/policy3.html' target='_blank' rel='noopener noreferrer'>Tietosuojaseloste / Privacy Policy</a><br/><br/>Olen lukenut ja hyväksyn ehdot.</p>",
      "<h2>Olet pian valmis haastatteluun!</h2><p>Muutama viimeinen juttu:<br/>- Olet rauhallisessa paikassa<br/>- Mikrofoni toimii<br/>- Sinulla on noin 15–20 minuuttia aikaa<br/><br/>Kun aloitat, vie haastattelu kerralla loppuun. Saamasi koodi ei myöskään enää toimi sen jälkeen, kun olet aloittanut haastattelun. Jos haastattelu jostain syystä keskeytyy teknisen ongelman takia, pyydä koodin uudelleenaktivointi osoitteesta info@talentconsulting.fi.<br/><br/>Vastaa rennosti, omin sanoin – juuri sinun äänesi on se mitä haluamme kuulla.</p>"
    
    ];
    const ohjeetEng = [
      "<h2>Welcome</h2><p>Hello, great to have you here!<br/><br/>This interview has been designed to be as easy as possible. You only need to answer the questions out loud, and the platform handles everything else automatically.<br/><br/>Your answers are sent directly to the recruitment lead, who reviews them. Final evaluation is always done by a human.<br/><br/>Next, we’ll quickly go through the instructions. This takes at most a couple of minutes.</p>",
      `<h2>How the interview works</h2><p>The platform guides you forward automatically – you only need to answer the questions by speaking.<br/><br/>For each question:<br/>- You get 20 seconds to read the question calmly<br/>- After that, you have ${time} seconds to answer out loud<br/><br/>When time runs out, the platform automatically moves to the next question.<br/><br/>If you finish before time is up, you can move forward yourself by pressing the "Next question" button.<br/><br/>The interview proceeds from start to finish in one go – it cannot be paused and resumed later. This ensures all candidates are in the same situation.</p>`,
      "<h2>Microphone check</h2><p>First, let’s check that your microphone works.<br/><br/>The platform will ask for permission to use your microphone. Please allow it when your browser prompts you.<br/><br/>Check the microphone activity from the volume bar below – when you speak, the bar should move. If it does not respond, check your device’s microphone settings before continuing.</p>",
      `<h2>There are ${kysymykset.length} questions</h2><p>You’re almost ready to begin!<br/><br/>Once you have answered the last question, the platform confirms that the interview is complete and your answers have been sent forward.<br/><br/>Note: Confirmation may occasionally take a moment. Don’t worry if the page appears to be loading. Your answers are still saved and sent automatically. You can safely close the page even before the confirmation message appears.</p>`,
      "<h2>Privacy protection</h2><p>Please read the privacy information from the link below before starting the interview.<br/> <br/><a href='/policy3.html' target='_blank' rel='noopener noreferrer'>Privacy Policy / Tietosuojaseloste</a><br/><br/>I have read and accept the terms.</p>",
      "<h2>You’re almost ready for the interview!</h2><p>A few final checks:<br/>- You are in a quiet place<br/>- Your microphone works<br/>- You have about 15–20 minutes available<br/><br/>When you start, complete the interview in one sitting. Your code will no longer work after you have started the interview. If the interview is interrupted due to a technical issue, request code reactivation at info@talentconsulting.fi.<br/><br/>Answer naturally, in your own words – your authentic voice is exactly what we want to hear.</p>"
    ];

    const ohjeetSwe = [
      "<h2>Välkommen</h2><p>Hej, vad roligt att du är här!<br/><br/>Den här intervjun är utformad för att vara så enkel som möjligt. Du behöver bara svara på frågorna högt, och plattformen sköter resten automatiskt.<br/><br/>Dina svar skickas direkt till den rekryteringsansvariga, som går igenom dem. Den slutliga bedömningen görs alltid av en människa.<br/><br/>Nu går vi kort igenom instruktionerna. Det tar högst ett par minuter.</p>",
      `<h2>Så här går intervjun till</h2><p>Plattformen guidar dig automatiskt vidare – du behöver bara svara på frågorna genom att prata.<br/><br/>För varje fråga:<br/>- Du får 20 sekunder att läsa frågan i lugn och ro<br/>- Därefter har du ${time} sekunder att svara högt<br/><br/>När tiden är slut går plattformen automatiskt vidare till nästa fråga.<br/><br/>Om du har svarat innan tiden går ut kan du själv gå vidare genom att trycka på knappen "Nästa fråga".<br/><br/>Intervjun genomförs i ett svep från början till slut – den kan inte avbrytas och fortsätta senare. Detta säkerställer att alla kandidater är i samma situation.</p>`,
      "<h2>Mikrofonkontroll</h2><p>Låt oss först kontrollera att mikrofonen fungerar.<br/><br/>Plattformen ber om tillåtelse att använda mikrofonen. Godkänn begäran när webbläsaren frågar.<br/><br/>Kontrollera mikrofonens funktion i volymmätaren nedan – när du pratar ska mätaren röra sig. Om den inte reagerar, kontrollera enhetens mikrofoninställningar innan du fortsätter.</p>",
      `<h2>Det finns ${kysymykset.length} frågor</h2><p>Du är snart redo att börja!<br/><br/>När du har svarat på sista frågan bekräftar plattformen att intervjun är avslutad och att dina svar har skickats vidare.<br/><br/>Obs: Bekräftelsen kan ibland ta en stund. Oroa dig inte om sidan verkar ladda. Dina svar sparas och skickas ändå vidare automatiskt. Du kan stänga sidan säkert även innan bekräftelsemeddelandet visas.</p>`,
      "<h2>Integritetsskydd</h2><p>Läs informationen om integritet i länken nedan innan du börjar intervjun.<br/> <br/><a href='/policy3.html' target='_blank' rel='noopener noreferrer'>Integritetspolicy / Privacy Policy</a><br/><br/>Jag har läst och godkänner villkoren.</p>",
      "<h2>Du är snart redo för intervjun!</h2><p>Några sista saker:<br/>- Du sitter på en lugn plats<br/>- Mikrofonen fungerar<br/>- Du har cirka 15–20 minuter tillgängliga<br/><br/>När du börjar ska intervjun genomföras i ett svep. Din kod fungerar inte längre efter att du har startat intervjun. Om intervjun avbryts på grund av ett tekniskt problem, be om återaktivering av koden via info@talentconsulting.fi.<br/><br/>Svara avslappnat och med egna ord – det är just din röst vi vill höra.</p>"
    ];
    
  
    // Funktiot sivunumeroiden muuttamiseksi
    const seuraavaSivu = () => {
      if (pageNumber < ohjeet.length) {
        setpageNumber(pageNumber + 1);
      }
    };
  
    const edellinenSivu = () => {
      if (pageNumber > 1) {
        setpageNumber(pageNumber - 1);
      }
    };

    //Käynnistetään haastattelu. Ota mallia itse simusta.
    const aloitaHaastattelu = () => {
      setHaastettelu(true);
      
    };

    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [forgot, setForgot] = useState(false);
    const [finland, setFinland] = useState(false);
    const [logIn, setLogIn] = useState(false);
    const [newpass, setNewpass] = useState(false);
    const [titles, setTitles] = useState({signin: "Sign in",
    signup: "Sign up",
    forgot: "Forgot your password?",
    email: "Email",
    password:"Password",
    update: "Password update",
    placeemail: "Your email",
    yourpass: "Your password",
    createpass: "Create password",
    submit: "submit",
    new: "New password",
    loading: "Loading..."})

    const titlesFi = {
      signin: "Sign in",
        signup: "Rekisteröidy",
        forgot: "Unohditko salasanasi?",
        email: "Sähköposti",
        password:"Salasana",
        update: "Salasanan uusiminen",
        placeemail: "Sinun sähköpostiosoite",
        yourpass: "Sinun salasanasi",
        createpass: "Luo uusi salasana",
        submit: "Lähetä",
        new: "Uusi salasana",
        loading: "Loading...",
        id : "Käyttäjätunnus",
        id2 : "Kirjaudu sisään käyttäjätunnuksella",
        code : "Invitation code",
        code2 : "Enter your personal invitation code."
      }

      const titlesEng = {
        signin: "Sign in",
        signup: "Sign up",
        forgot: "Forgot your password?",
        email: "Email",
        password:"Password",
        update: "Password update",
        placeemail: "Your email",
        yourpass: "Your password",
        createpass: "Create a new password",
        submit: "submit",
        new: "New password",
        loading: "Loading...",
        id : "User ID",
        id2 : "Use your user ID to log in",
        code : "Invitation code",
        code2 : "Enter your personal invitation code."
        }

      const titlesSwe = {
        signin: "Logga in",
        signup: "Registrera",
        forgot: "Glömt ditt lösenord?",
        email: "E-post",
        password:"Lösenord",
        update: "Uppdatera lösenord",
        placeemail: "Din e-postadress",
        yourpass: "Ditt lösenord",
        createpass: "Skapa ett nytt lösenord",
        submit: "Skicka",
        new: "Nytt lösenord",
        loading: "Laddar...",
        id : "Användar-ID",
        id2 : "Logga in med ditt användar-ID",
        code : "Inbjudningskod",
        code2 : "Ange din personliga inbjudningskod."
        }

      

    const [info, setInfo] = useState('');
    const [info2, setInfo2] = useState('');

   
    useEffect(() => {
      // Hanki nykyinen URL
      if (name == ""){
  
  
      const currentUrl = window.location.href;
  
      // Luo URL-objekti ja jaa polku
      const parsedUrl = new URL(currentUrl);
      const pathParts = parsedUrl.pathname.split('/');
  
      // Ota haluttu osa (tässä tapauksessa prosource)
      if (pathParts.length > 1) {
        setName(pathParts[1]); // tallennetaan "prosource" tilaan
      }
      }
   
    }, [name]);

    useEffect(() => {
      
      if(haastattelu){
        onAddHaastattelu(true);
      
      }
      
    }, [haastattelu]);

    useEffect(() => {

      
      if(kieli != ""){
        if (kieli == "Suomi"){
          setOhjeet(ohjeetFin);
          setOikealle(oikealleFin);
          setVasemmalle(vasemmalleFin);
          setValmisNappi(valmisNappiFin);
          setEhdot("Olen lukenut ja hyväksynyt ehdot.");
        }else if (kieli == "Ruotsi"){
   
          setOhjeet(ohjeetSwe);
          setOikealle(oikealleSwe);
          setVasemmalle(vasemmalleSwe);
          setValmisNappi(valmisNappiSwe);
          setEhdot("Jag har läst och godkänt villkoren.");

        }else if (kieli == "Englanti"){

          setOhjeet(ohjeetEng);
          setOikealle(oikealleEng);
          setVasemmalle(vasemmalleEng);
          setValmisNappi(valmisNappiEng);
          setEhdot("I have read and accepted the terms.");
        }
      
      
      }
    
    }, [kieli]);


    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        handleSend(e);
      }
      else if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation(); 
        // Voit myös tehdä muita toimintoja tässä, jos haluat
      }
    };
    const handleKeyDown2 = (e) => {
      if (e.key === 'Enter') {
        handleSend(e);
      }
      else if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation(); 
        // Voit myös tehdä muita toimintoja tässä, jos haluat
      }
    };
    
    const handleSend = async (event) => {

      event.preventDefault();
      
      setIsLoading(true);
        fetch('https://us-central1-tcgai-c07e9.cloudfunctions.net/api/hakija', {
        //fetch('http://localhost:5001/tcgai-c07e9/us-central1/api/hakija', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email: email, group: name})
      })

      .then(response => response.json())
      .then(data => { 
    
          setIsLoading(false);
          
          if (data.status == "ok" ){

      
            const kysymyksetTaulukkona = JSON.parse(data.final); // Muuntaa merkkijonon taulukoksi
            setKysymykset(kysymyksetTaulukkona); // Tallentaa taulukon tilaan
            setOwner(data.owner);
            setTime(data.aika);
            setPosition(data.position);
            setLogIn(true);
    
            setMandaatti(data.mandaatti);
            setKieli(data.kieli);
           
          }
          else if (data.status == "vastannut jo" ){
            if(!finland){
      
              setInfo("You have already answered the questions, you cannot answer again");
              setInfo2("You have already answered the questions, you cannot answer again");
            }else{          
      
              setInfo("You have already answered the questions, you cannot answer again");
              setInfo2("You have already answered the questions, you cannot answer again");             
            }

          }

          else if (data.status == "ei ok"){
            if(!finland){
      
              setInfo("The invitation code is not valid");
              setInfo2("The invitation code is not valid");
            }else{          
  
              setInfo("The invitation code is not valid");
              setInfo2("The invitation code is not valid");
              
            }
          }
          else {
            if(!finland){
            setInfo("Something went wrong, please contact Lassi.");
            setInfo2("Something went wrong, please contact Lassi.");
            }else {
              setInfo("Jotain meni pieleen, ole hyvä ja ota yhteyttä Lassiin.");
              setInfo2("Jotain meni pieleen, ole hyvä ja ota yhteyttä Lassiin.");
            }
          }
        }
      ) 
      .catch(error => console.error(error));  

     setInfo("");
    setInfo2("");
      
      //setInfo2("Coming soon!");
    };


      //Google signin if needed
      useEffect(() => {
        const domain = window.location.hostname;

        if (domain === 'theinterviewsimulator.com' || domain === 'www.theinterviewsimulator.com') {
          setFinland(false);
          setTitles(titlesEng);
        } else {
          setFinland(true);
          setTitles(titlesFi);
        }

        // Cleanup function, which removes the user state listener.
      }, []);
    
      
      useEffect(() => {
        const handleKeyDown = (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
          }
        };
        const handleKeyDown2 = (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
          }
        };
    
    
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keydown', handleKeyDown2);
        
    
        // Komponentin poistuessa, poista tapahtumankäsittelijä
        return () => {
          window.removeEventListener('keydown', handleKeyDown);
          window.removeEventListener('keydown', handleKeyDown2);
        };
      }, []);

      const handleClosee = () => {
        setInfo2(""); // Nollaa info2:n arvo
      };

    //Haastatteluosi-----------------------------------------------------------------------------------------------------------------------------




  
    if (!isLoading && !forgot && info2 == "" && !logIn && !haastattelu) {
      return (
        <>
          <style>
            {`
              .custom-input::placeholder {
                color: #f0f0f0;
                opacity: 1;
              }
              .custom-input:focus {
                border-color: #ffd700;
                box-shadow: 0 0 0 0.2rem rgba(255, 215, 0, 0.5);
                outline: none;
              }
              .SignIn {
                background-color: #2c2c2c !important;
                border-color: #2c2c2c !important;
                color: #ffffff !important;
              }
              .SignIn:hover {
                background-color: #3a3a3a !important;
                border-color: #3a3a3a !important;
                color: #ffffff !important;
              }
            `}
          </style>
    
          <div style={{ backgroundColor: "#2c2c2c", minHeight: "100vh", color: "white" }}>
            <Container
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "10px"
              }}
            >
              <img className="FormLogo" src={Pro} style={{ height: "20vh", marginTop: "0vh", marginBottom: "0vh" }} />
              <h1 className="FormTitle" style={{ fontSize: "1.95em", marginBottom: "0vh", color: "white" }}>
                The Interview Simulator
              </h1>
              <h3 style={{ fontSize: "1.3em", color: "white" }}>
                {isLoginForm ? titles.signin : titles.signin}
              </h3>
              <Row
                className="justify-content-md-center"
                style={{
                  width: "100%",
                  height: "55vh",
                  display: "flex",
                  justifyContent: "center"
                }}
              >
                <Col>
                  <Card className="Card" style={{ width: "80%", height: "30vh", marginLeft: "10%", backgroundColor: "#3a3a3a", color: "white" }}>
                    <Card.Body
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        height: "100%",
                        borderRadius: "0"
                      }}
                    >
                      <Form>
                        <Form.Group>
                          <Form.Label htmlFor="email" style={{ color: "white" }}>{titles.code}</Form.Label>
                          <Form.Control
                            id="email"
                            type="email"
                            placeholder={titles.code2}
                            onChange={(e) => setEmail(e.target.value)}
                            onKeyDown={handleKeyDown}
                            className="custom-input"
                            style={{ backgroundColor: "#555", color: "white", border: "1px solid #777" }}
                          />
                        </Form.Group>
                      </Form>
                      <Button
                        className="SignIn"
                        variant="primary"
                        type="submit"
                        style={{ marginTop: "0vh", width: "40%", marginRight: "auto", marginLeft: "auto" }}
                        onClick={(e) => handleSend(e)}
                      >
                        {isLoginForm ? titles.signin : titles.signin}
                      </Button>
                    </Card.Body>
                  </Card>
    
                  <div className="formInfo" style={{ marginLeft: "10%", color: "white" }}>{info}</div>
                </Col>
              </Row>
            </Container>
          </div>
        </>
      )
    }
    
    else if (logIn && !haastattelu){ //Tähän nyt itse sisältö...Eli eka varmaan jokin ohje

      return (
        <Container fluid className="interview-instructions-page">
          <main className="interview-instructions-scroll">
            {/* Renderöidään HTML-sisältö */}
            <div 
                dangerouslySetInnerHTML={{ __html: ohjeet[pageNumber - 1] }} 
                style={{
                  fontSize: '1.2rem',       // Asetetaan tekstin koko
                  lineHeight: '1.4',        // Riviväli, joka tekee tekstistä selkeämmän
                  wordBreak: 'break-word',  // Varmistaa, että pitkät sanat katkeavat tarpeen mukaan
                }}
              />
              {pageNumber === 3 && (
                <Col >
                  <Volume/>
                </Col>
              )}

          {pageNumber === 5 && (
              <div style={{ marginTop: '10px' }}>
                <input
                  type="checkbox"
                  id="acceptPrivacy"
                  checked={isAccepted}
                  onChange={() => setIsAccepted(!isAccepted)}
                />
                <label htmlFor="acceptPrivacy" style={{ marginLeft: '5px' }}>
                  {ehdot}
                </label>
              </div>
            )}    
            

          </main>
  
          {/* Jos kysymykset-taulukossa on dataa, renderöidään lista */}
          
            
      
          <div
            className="interview-instructions-footer"
            style={{
              position: 'fixed',
              bottom: '0',
              left: '0',
              right: '0',
              padding: '10px',
              backgroundColor: 'white',
              boxShadow: '0 -2px 5px rgba(0,0,0,0.1)',
              zIndex: 1000,
            }}
          >
            <Row>
              <Col className="text-start">
                <Button
                  variant="primary"
                  onClick={edellinenSivu}
                  disabled={pageNumber === 1}
                >
                  {vasemmalle}
                </Button>
              </Col>

              {pageNumber === 6 && (
                <Col className="text-center">
                  <Button
                    variant="success"
                    onClick={aloitaHaastattelu}
                    style={{
                      whiteSpace: 'nowrap',
                      width: 'auto',
                    }}
                  >
                    {valmisNappi}
                  </Button>
                </Col>
              )}

              <Col className="text-end">
                <Button
                  variant="primary"
                  onClick={seuraavaSivu}
                  disabled={pageNumber === ohjeet.length || (pageNumber === 5 && !isAccepted)}
                >
                  {oikealle}
                </Button>
              </Col>
            </Row>

            {/* Valintaruutu ja Privacy Policy linkki näkyy vain, jos ollaan viimeisellä sivulla */}
            
          </div>
                      
                           
        </Container>
      );
    }
    //Tämä silloin kun haastattelu on käynnissä
    else if (logIn && haastattelu){ //Tähän nyt itse sisältö...Eli eka varmaan jokin ohje

      return (
        <div>
            <Simulator kre={kysymykset.length} lan={kieli} que={kysymykset} haa={haastattelu} ema={email} own={owner} man={mandaatti} tim={time}/>   
        </div>
      );
    }
    else {
      return (

        <div style={{ textAlign: "center" }}>
          <img className="logopikku" src={Logopikku} alt="kuva" />
          {info2 == "" && (
            <div>
          <p>{titles.loading}</p>
          </div>
          )}
          {info2 !== "" && (
            <div>
              <p>{info2}</p>
              
              <Button
                    className='SignIn'
                    variant="primary"
                    type="submit"
                    style={{marginTop:"0vh", width:"40%", marginRight:"auto", marginLeft:"auto"}}
                    onClick={(e)=> handleClosee(e)}
                    >
                    {finland ? <p>Sulje</p> : <p>Close</p>}
                  
                </Button>
            </div>
          )}
        </div>
      );
    }
    ;}

export default AuthenticationForm2;


//`<h2>Haastattelu simuloi normaalia haastatteluprosessia.</h2><p>Haastattelu alkaa 20 sekunnin laskurilla, jonka jälkeen sinulla on 90 sekuntia aikaa vastata kysymykseen, jonka jälkeen seuraa jälleen 20 sekunnin tauko.<br/><br/>Tauon jälkeen seuraava kysymys ilmestyy automaattisesti ja 90 sekunnin ajastin käynnistyy. Haastatteluprosessia ei voi keskeyttää.</p>`,
